import {
  SET_SELECTED_OPTION, LIST_EVENTS, LIST_EVENTS_FAILURE, LIST_EVENTS_SUCCESS, UPDATE_EVENTS_FILTER, CREATE_INVOICE, CREATE_INVOICE_SUCCESS, CREATE_INVOICE_FAILURE, GET_CARE_UNIT, GET_CARE_UNIT_SUCCESS, GET_CARE_UNIT_FAILURE
} from './ReportActionTypes';
import {errorMessage} from "../../../components/AjaxHelpers";


export const setSelectedOption = (option) => ({
  type: SET_SELECTED_OPTION,
  payload: option,
});

// ACTIONS FOR FAKTURAUNDERLAG
export const updateEventListFilter = (filter) => ({
  type: UPDATE_EVENTS_FILTER,
  filter
})
export const listEvents = () => ({
  type: LIST_EVENTS,
})
export const listEventsSucceeded = (events) => ({
  type: LIST_EVENTS_SUCCESS,
  events
})
export const listEventsFailed = (error) => ({
  type: LIST_EVENTS_FAILURE,
  error
})

export const createInvoice = () => ({
  type: CREATE_INVOICE,
})

export const getCareUnit = (careUnitId) => ({
  type: GET_CARE_UNIT,
  careUnitId
})

export const getCareUnitSucceeded = (careUnit) => ({
  type: GET_CARE_UNIT_SUCCESS,
  careUnit
});
export const getCareUnitFailed = (error) => ({
  type: GET_CARE_UNIT_FAILURE,
  message: errorMessage(error, "Fel vid försök att hämta vårdenhet"),
});

export const createInvoiceSuccess = (payload) => {
  //Create a Blob from the PDF Stream
  const blob = new Blob(
      [payload.response],
      {type: 'application/pdf'});
  // let file = new File([blob], "remiss.pdf",{lastModified: 1534584790000, type: 'application/pdf'});
  //Build a URL from the file 
  const fileURL = URL.createObjectURL(blob);
  window.open(fileURL); // Opens the referral pdf in a new tab
  return({
      type: CREATE_INVOICE_SUCCESS,
      payload: payload.response,
      fileURL,
      fileCreatedDate: new Date(),
  })
}

export const createInvoiceFailure = (error) => ({
  type: CREATE_INVOICE_FAILURE,
  message: errorMessage(error, 'Fel vid försök att skapa fakturaunderlag'),
})